import getAlerts from 'modules/emergencies/api/getAlerts';
import useSWR from 'swr';

const useAlertsList = ({ currentPage }) => {
  const { data: alertsData, error: alertsError } = useSWR(
    [`price-negotiation/alerts/`, currentPage],
    getAlerts,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const isLoadingAlerts = typeof alertsData === 'undefined' && !alertsError;

  return {
    alertsData,
    alertsError,
    isLoadingAlerts,
  };
};

export default useAlertsList;
